import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { LucideIcon } from 'lucide-react';

interface SimpleAnalyticsCardProps {
  title: string;
  value: string | number;
  description?: string;
  icon?: LucideIcon;
  trend?: {
    value: number;
    label: string;
  };
}

export const SimpleAnalyticsCard: React.FC<SimpleAnalyticsCardProps> = ({
  title,
  value,
  description,
  icon: Icon,
  trend,
}) => {
  const trendColor =
    trend && trend.value > 0 ? 'text-green-600' : 'text-red-600';

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{value}</div>
        {description && (
          <p className="text-xs text-muted-foreground mt-1">{description}</p>
        )}
        {trend && (
          <div className={`text-xs ${trendColor} mt-1`}>
            {trend.value > 0 ? '+' : ''}
            {trend.value}% {trend.label}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
